import React from 'react';
import { motion } from 'framer-motion';
import './Performance.css';

const performanceData = [
  {
    id: "#1",
    title: "Precision in Delivery",
    desc: "Planned and monitored vehicle movements ensuring safe, on-time delivery nationwide.",
    color: "red-card"
  },
  {
    id: "#2",
    title: "Tailored Logistics Solutions",
    desc: "Custom transport solutions for car carriers, heavy, and ODC cargo.",
    color: "black-card"
  },
  {
    id: "#3",
    title: "Safety & Compliance First",
    desc: "100% CMVR-compliant fleet with trained drivers and preventive maintenance.",
    color: "red-card"
  }
];

const Performance = () => {
  return (
    <section className="performance-section">
      <div className="performance-container">
        
        <div className="performance-header">
          <h2 className="perf-title">
            Built on legacy. <span className="highlight-red">Trusted for reliability.</span>
          </h2>
          <h2 className="perf-title subtitle">Chosen for performance.</h2>
        </div>

        <div className="cards-stack">
          {performanceData.map((item, index) => (
            <motion.div 
              key={index}
              className={`perf-card ${item.color}`}
              // Hover effect: Slides -30px to the left smoothly
              whileHover={{ 
                x: -30, 
                transition: { duration: 0.4, ease: "easeOut" }
              }}
            >
              <div className="card-content">
                <span className="card-number">{item.id}</span>
                <div className="card-text-group">
                  <h3 className="card-title">{item.title}</h3>
                  <p className="card-desc">{item.desc}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Performance;